import { Action } from '@ngrx/store';
import {LicenseSettingFilter} from '../license-mgt.model';

export enum LicenseSettingListFilterActionTypes {
  LoadLicenseSettingListFilters = '[LicenseSettingListFilter] Load LicenseSettingListFilters',
  SelectLicenseSettingListFilters = '[[LicenseSettingListFilter] Select LicenseSettingListFilters]'
}

export class LoadLicenseSettingListFilters implements Action {
  readonly type = LicenseSettingListFilterActionTypes.LoadLicenseSettingListFilters;
}

export class SelectLicenseSettingListFilters implements Action {
  readonly type = LicenseSettingListFilterActionTypes.SelectLicenseSettingListFilters;
  constructor(public payload: LicenseSettingFilter) {}
}

export type LicenseSettingListFilterActions =
  LoadLicenseSettingListFilters
  | SelectLicenseSettingListFilters;
